import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import postCoverTecnicas from "@/assets/cover-tecnicas-fechamento.jpg";
import postCoverIA from "@/assets/cover-ia-treinamento.jpg";
import postCoverObjecoes from "@/assets/cover-objecoes-preco.jpg";
import postCoverGamificacao from "@/assets/cover-gamificacao.jpg";
import postCoverColdcalling from "@/assets/cover-cold-calling.jpg";
import postCoverEstrategias from "@/assets/cover-13-estrategias.jpg";
import postCoverComoVenderMais from "@/assets/cover-como-vender-mais.jpg";
import postCoverPreVendas from "@/assets/cover-pre-vendas.jpg";
import postCoverSocialSelling from "@/assets/cover-social-selling.jpg";
import postCoverNegociacao from "@/assets/cover-negociacao-b2b.jpg";
import postCoverFunil from "@/assets/cover-funil-vendas.jpg";
import postCoverTreinamentoIA from "@/assets/cover-treinamento-90-dias.jpg";
import postCoverTreinamento from "@/assets/cover-treinamento-de-vendas.jpg";
import postCoverCapacitacao from "@/assets/cover-capacitacao-em-vendas.jpg";
import postCoverCopa from "@/assets/cover-licoes-copa-2026.jpg";
import postCoverMontarEquipe from "@/assets/cover-montar-equipe-vendas.jpg";
import postCoverScript from "@/assets/cover-script-de-vendas.jpg";
import postCoverTreinarNovos from "@/assets/cover-treinar-vendedores-novos.jpg";
import postCoverKpis from "@/assets/cover-metricas-kpis-vendas.jpg";
import postCoverProspeccao from "@/assets/cover-prospeccao-b2b.jpg";
import postCoverPlaybook from "@/assets/cover-playbook-de-vendas.jpg";
import postCoverPipeline from "@/assets/cover-gestao-de-pipeline.jpg";
import postCoverRapport from "@/assets/cover-rapport-persuasao.jpg";
import postCoverConsultor from "@/assets/cover-o-que-faz-consultor-comercial.jpg";
import postCoverConsultoriaVendas from "@/assets/cover-consultoria-de-vendas.jpg";
import postCoverFollowUp from "@/assets/cover-follow-up-que-converte.jpg";

const Blog = () => {
  const blogPosts = [
    {
      title: "Follow-up Que Converte: Como Fazer Follow-up em Vendas e Quando Insistir",
      excerpt: "Como fazer follow-up em vendas sem ser chato: cadência de contatos, canais certos, mensagens prontas e o ponto exato entre insistir no cliente e encerrar.",
      category: "Técnicas de Vendas",
      date: "10 Set 2026",
      readTime: "11 min",
      link: "/posts/follow-up-que-converte",
      image: postCoverFollowUp
    },
    {
      title: "O Que Faz um Consultor Comercial (e Quando Sua Empresa Precisa de Um)",
      excerpt: "Atribuições do dia a dia, diferença entre consultor comercial e vendedor, quanto ganha e os sinais de que sua operação precisa de um consultor de vendas.",
      category: "Gestão Comercial",
      date: "09 Set 2026",
      readTime: "10 min",
      link: "/posts/o-que-faz-um-consultor-comercial",
      image: postCoverConsultor
    },
    {
      title: "Consultoria de Vendas: O Que É, Quanto Custa e Que Resultado Esperar",
      excerpt: "Como funciona um projeto de consultoria de vendas etapa por etapa, formatos de investimento, prazos de resultado e como escolher quem contratar.",
      category: "Estruturação Comercial",
      date: "08 Set 2026",
      readTime: "11 min",
      link: "/posts/consultoria-de-vendas",
      image: postCoverConsultoriaVendas
    },
    {
      title: "Rapport e Persuasão: Técnicas de Rapport e Gatilhos Mentais Para Vender Mais",
      excerpt: "Técnicas de rapport, como gerar confiança na venda e gatilhos mentais éticos para conduzir negociações com mais conexão e conversão.",
      category: "Técnicas de Vendas",
      date: "06 Set 2026",
      readTime: "11 min",
      link: "/posts/rapport-persuasao",
      image: postCoverRapport
    },
    {
      title: "Gestão de Pipeline: Como Gerenciar o Funil de Vendas e Prever Receita",
      excerpt: "Como gerenciar pipeline na prática: etapas do funil de vendas por decisão do cliente, higiene do CRM para vendas, cobertura, previsão e revisão semanal.",
      category: "Gestão Comercial",
      date: "05 Set 2026",
      readTime: "12 min",
      link: "/posts/gestao-de-pipeline",
      image: postCoverPipeline
    },
    {
      title: "Playbook de Vendas: Como Criar o Manual do Vendedor Que o Time Usa",
      excerpt: "Como criar playbook de vendas na prática: os 8 capítulos do manual do vendedor, como escrever a partir do que já funciona e como implantar o playbook comercial.",
      category: "Processo Comercial",
      date: "04 Set 2026",
      readTime: "12 min",
      link: "/posts/playbook-de-vendas",
      image: postCoverPlaybook
    },
    {
      title: "Prospecção B2B: Como Prospectar Clientes e Encher o Pipeline",
      excerpt: "Como prospectar clientes B2B na prática: ICP e gatilhos, cadência de prospecção outbound em 15 dias, canais que geram reunião e métricas de geração de leads B2B.",
      category: "Prospecção",
      date: "02 Set 2026",
      readTime: "13 min",
      link: "/posts/prospeccao-b2b",
      image: postCoverProspeccao
    },
    {
      title: "Métricas e KPIs de Vendas: Os Benchmarks Para Saber se Seus Números Estão Bons",
      excerpt: "KPI vendas e métricas comerciais com exemplos numéricos e benchmarks por setor: conversão, ciclo, win rate, CAC, LTV e como medir desempenho do vendedor.",
      category: "Gestão Comercial",
      date: "31 Ago 2026",
      readTime: "14 min",
      link: "/posts/metricas-e-kpis-de-vendas",
      image: postCoverKpis
    },
    {
      title: "Como Treinar Vendedores Novos: O Que Realmente Encurta o Ramp-up",
      excerpt: "Onboarding vendedor sem manual engessado: treinamento da equipe comercial na prática, exemplos de conversa e o que de fato encurta o ramp-up de vendas.",
      category: "Desenvolvimento de Time",
      date: "28 Ago 2026",
      readTime: "11 min",
      link: "/posts/como-treinar-vendedores-novos",
      image: postCoverTreinarNovos
    },
    {
      title: "Script de Vendas Pronto: O Roteiro Que Abre Porta e Marca o Próximo Passo",
      excerpt: "Roteiro de ligação comercial e script de prospecção: anatomia em 6 blocos, VSL, técnicas de perguntas, rapport e modelo em .txt para baixar e preencher.",
      category: "Processo Comercial",
      date: "25 Ago 2026",
      readTime: "12 min",
      link: "/posts/script-de-vendas-pronto",
      image: postCoverScript
    },
    {
      title: "Como Montar Uma Equipe de Vendas do Zero: O Passo a Passo Completo",
      excerpt: "10 passos para montar equipe comercial e estruturar time de vendas: quantos contratar, scorecard, playbook, comissão, rampagem de 90 dias e treino semanal.",
      category: "Estrutura Comercial",
      date: "22 Ago 2026",
      readTime: "17 min",
      link: "/posts/como-montar-equipe-de-vendas-do-zero",
      image: postCoverMontarEquipe
    },
    {
      title: "Lições da Copa 2026 Para Vendas: Não Perca o Gol na Hora do Pênalti",
      excerpt: "A 5 dias da final da Copa, veja 7 lições dos gramados que separam times comerciais campeões dos que perdem a meta no minuto 90. Treino contínuo com IA.",
      category: "Alta Performance",
      date: "14 Jul 2026",
      readTime: "10 min",
      link: "/posts/licoes-copa-2026-vendas",
      image: postCoverCopa
    },
    {
      title: "Funil de Vendas em 2026: Como Construir Pipeline Previsível Que Triplica Conversões",
      excerpt: "10 passos práticos: ICP, etapas binárias, taxa de conversão por estágio, forecast ponderado, lead scoring com IA, higienização e treino por etapa.",
      category: "Gestão Comercial",
      date: "01 Jun 2026",
      readTime: "18 min",
      link: "/posts/funil-vendas-2026",
      image: postCoverFunil
    },
    {
      title: "Negociação B2B em 2026: Como Conduzir Reuniões Que Fecham Grandes Contratos",
      excerpt: "13 passos práticos: BATNA, ZOPA, ancoragem, concessões, stakeholders, contratos, walk-away power e treino com IA. Preserve margem e feche grandes contratos.",
      category: "Negociação Avançada",
      date: "05 Mai 2026",
      readTime: "23 min",
      link: "/posts/negociacao-b2b-2026",
      image: postCoverNegociacao
    },
    {
      title: "Social Selling no LinkedIn em 2026: Como Gerar Pipeline Sem Cold Call",
      excerpt: "Guia completo em 13 passos: perfil, Sales Navigator, conteúdo, engajamento, DM, eventos, métricas e integração ao CRM. Pipeline previsível sem cold call.",
      category: "Prospecção Digital",
      date: "22 Abr 2026",
      readTime: "24 min",
      link: "/posts/social-selling-linkedin-2026",
      image: postCoverSocialSelling
    },
    {
      title: "Pré-Vendas em 2026: Como Estruturar um Time SDR/BDR Que Gera Pipeline Previsível",
      excerpt: "Guia completo com 13 passos para estruturar pré-vendas: ICP, cadência multicanal, qualificação BANT/CHAMP, handoff, métricas e IA aplicada.",
      category: "Estrutura Comercial",
      date: "18 Mar 2026",
      readTime: "22 min",
      link: "/posts/pre-vendas-sdr-bdr-2026",
      image: postCoverPreVendas
    },
    {
      title: "Como Vender Mais em 2026: 13 Passos Práticos Para Aplicar Hoje",
      excerpt: "O manual definitivo com checklist, cases reais e storytelling de quem já aplicou e vendeu. Comece hoje mesmo!",
      category: "Manual Prático",
      date: "15 Fev 2026",
      readTime: "20 min",
      link: "/posts/como-vender-mais-2026",
      image: postCoverComoVenderMais
    },
    {
      title: "13 Estratégias de Vendas Para Dominar Qualquer Negociação em 2026",
      excerpt: "SPIN, BANT, MEDDIC, CHAMP e mais 9 frameworks explicados com tabela comparativa, níveis de maturidade e aplicação prática. O guia mais completo de técnicas de vendas.",
      category: "Técnicas de Vendas",
      date: "13 Jan 2026",
      readTime: "25 min",
      link: "/posts/13-estrategias-vendas-2026",
      image: postCoverEstrategias
    },
    {
      title: "Cold Calling em 2026: Está Morto ou Ainda Funciona?",
      excerpt: "Análise completa e atualizada sobre prospecção por telefone. Técnicas modernas, ferramentas de IA e estratégias comprovadas.",
      category: "Prospecção",
      date: "10 Dez 2025",
      readTime: "15 min",
      link: "/posts/cold-calling-2026",
      image: postCoverColdcalling
    },
    {
      title: "Gamificação em Vendas: O Poder dos Pontos e Rankings",
      excerpt: "Descubra como sistemas de gamificação podem motivar sua equipe comercial.",
      category: "Gestão",
      date: "15 Nov 2025",
      readTime: "7 min",
      link: "/posts/gamificacao-vendas",
      image: postCoverGamificacao
    },
    {
      title: "Objeções de Preço: Como Transformar em Oportunidade",
      excerpt: "Aprenda a lidar com a objeção mais comum em vendas e converter prospects em clientes.",
      category: "Negociação",
      date: "20 Out 2025",
      readTime: "5 min",
      link: "/posts/objecoes-preco",
      image: postCoverObjecoes
    },
    {
      title: "Como a IA Está Revolucionando o Treinamento de Equipes Comerciais",
      excerpt: "Entenda como a inteligência artificial pode acelerar o desenvolvimento de vendedores e reduzir custos.",
      category: "Tecnologia",
      date: "18 Set 2025",
      readTime: "6 min",
      link: "/posts/ia-treinamento-vendas",
      image: postCoverIA
    },
    {
      title: "7 Técnicas de Fechamento que Todo Vendedor Precisa Dominar",
      excerpt: "Descubra as estratégias mais eficazes para fechar vendas complexas e aumentar sua taxa de conversão.",
      category: "Técnicas de Vendas",
      date: "20 Ago 2025",
      readTime: "8 min",
      link: "/posts/7-tecnicas-fechamento",
      image: postCoverTecnicas
    },
    {
      title: "Treinamento de Vendas com IA: Como Acelerar Resultados da Equipe Comercial em 90 Dias",
      excerpt: "Por que o treinamento tradicional falha, como a IA muda o jogo, pilares de um programa moderno, métricas que importam e cronograma realista de 90 dias.",
      category: "Treinamento de Vendas",
      date: "22 Jul 2025",
      readTime: "15 min",
      link: "/posts/treinamento-de-vendas-com-ia-como-acelerar-resultados-da-equipe-comercial-em-90-dias",
      image: postCoverTreinamentoIA
    },
    {
      title: "Treinamento de Vendas: O Guia Definitivo Para Transformar Sua Equipe Comercial",
      excerpt: "Pilares, tipos, metodologia, métricas, cases reais e o passo a passo para implantar um programa de treinamento comercial que sai do PowerPoint e chega no resultado.",
      category: "Treinamento Comercial",
      date: "10 Jun 2025",
      readTime: "14 min",
      link: "/posts/treinamento-de-vendas",
      image: postCoverTreinamento
    },
    {
      title: "Capacitação em Vendas: O Guia Definitivo Para Estruturar Sua Equipe Comercial",
      excerpt: "Pilares, tipos, metodologia, métricas, livros de referência e o passo a passo para implantar um programa de capacitação em vendas previsível e mensurável.",
      category: "Capacitação Comercial",
      date: "13 Mai 2025",
      readTime: "16 min",
      link: "/posts/capacitacao-em-vendas",
      image: postCoverCapacitacao
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Blog | Bianchim Business - Dicas e Estratégias de Vendas"
        description="Artigos, dicas e estratégias para melhorar suas vendas. Conteúdo exclusivo sobre técnicas de vendas, negociação, gestão comercial e muito mais."
        canonicalUrl="https://bianchimbusiness.com.br/blog"
      />
      <Header />

      {/* Hero Section */}
      <section className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="text-gradient-brand">
              Blog Bianchim Business
            </span>
          </h1>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Dicas, estratégias e novidades do mundo das vendas para impulsionar seus resultados
          </p>
        </div>

        {/* Blog Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => {
            const content = (
              <Card className="overflow-hidden border-border bg-card hover:border-primary/30 transition-all cursor-pointer group h-full flex flex-col">
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="text-xs font-medium text-primary bg-primary/10 px-2 py-1 rounded-full">
                      {post.category}
                    </span>
                    <span className="text-xs text-muted-foreground">{post.date}</span>
                    <span className="text-xs text-muted-foreground">• {post.readTime}</span>
                  </div>
                  <h2 className="text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors">
                    {post.title}
                  </h2>
                  <p className="text-muted-foreground text-sm flex-1">
                    {post.excerpt}
                  </p>
                  <div className="mt-4 flex items-center text-primary font-medium text-sm">
                    Ler artigo
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Card>
            );

            return post.link ? (
              <Link key={index} to={post.link} className="block h-full">
                {content}
              </Link>
            ) : (
              <div key={index} className="opacity-60 cursor-not-allowed h-full">
                {content}
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
